export const fetchOption = process.env.REACT_APP_USE_NOTI_SERVICE
  ? undefined
  : {
      refetchInterval: 5000,
    };
